import TableComponent from '../../Common/Charts/TableCharts';
import { number } from '../../Common/Util/number';
import { useEstablishmentLocationChartsDataContext } from './hooks/useEstablishmentLocationChartsDataContext';
import { useSanitizeData } from '../Common/hooks/useSanitizeData';
import '../Common/Styles/Ciha.css'

export const TopMunicipalities = () => {
    const { chartData } = useEstablishmentLocationChartsDataContext();

    const tableColumns = [
        {
            key: 'codigo',
            header: 'Código',
            headerStyle: { fontWeight: '700' },
            cellStyle: { fontWeight: '400' },
            formatter: (value) => ( <span className="table-badge"> {value} </span> )
        },
        {
            key: 'nome',
            header: 'Nome',
            headerStyle: { fontWeight: '700' },
            cellStyle: { fontWeight: '400' }
        },
        {
            key: 'total',
            header: 'Total',
            headerStyle: { fontWeight: '700', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'pct',
            header: '%',
            headerStyle: { fontWeight: '700', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => `${number.formatToBRNumber(value)}%`
        }
    ];

    const rawData = chartData?.topMunicipalities || [];

    const sanitizedData = useSanitizeData(rawData).map((item) => ({
        ...item,
        codigo: item.codigo || 'Não informado',
        nome: item.nome || 'Não informado',
    }));

    return (
            <TableComponent
                className="no-spacing-table"
                data={sanitizedData}
                columns={tableColumns}
                title="Top 20 Municipios - Volume de Atendimentos"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="670px"
            />
        
    );
};